import Animations from "./app/useful/animations";
import Performance from "./app/useful/performance";

/**
 * Base scripts running all over the site
 */
new Performance();
new Animations(document);